import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'mochi-react-component';
import className from 'classnames/bind';
import repo from 'service/repository';
import styles from 'feature/common/landing/usage/index.module.scss';
import map from 'images/landing/usage_map.png';
import pin from 'images/landing/usage_pin.png';
import { PATHS } from 'config';
import { devicePlateForm } from 'utils/device-util';
import { currentUrl } from 'utils/url-helper';
import amplitudeService from 'service/amplitude';
import { useIsMounted } from 'utils/mount-helper';
import useIntersect from 'utils/intersect-helper';

const Usage = () => {
  const cx = className.bind(styles);
  const { t } = useTranslation();
  const usageRef = useRef();
  const [pinshow, setPinShow] = useState(false);
  const [contentShow, setContentShow] = useState(false);
  const [streetParkingBillCities, setStreetParkingBillCities] = useState([]);
  const langIsCn = useTranslation().i18n.language === 'tw';
  const isMountedRef = useIsMounted();

  const [setElement] = useIntersect(() => {
    setTimeout(() => {
      setPinShow(true);
    }, 0);
    setTimeout(() => {
      setContentShow(true);
    }, 400);
  });

  useEffect(() => {
    setElement([usageRef.current]);
  }, [setElement]);

  useEffect(() => {
    const getBillCities = async () => {
      const [err, data] = await repo.fetchStreetParkingBillCities();
      if (err) {
        console.log(err);
        return;
      }
      if (isMountedRef.current) setStreetParkingBillCities(data);
    };
    getBillCities();
  }, [isMountedRef]);

  const pinClass = cx({
    pin: true,
    show: pinshow,
  });

  const contentClass = cx({
    content: true,
    show: contentShow,
  });

  const fontSize = () => {
    return devicePlateForm() === 'desktop' ? `14px` : `12px`;
  };

  const supportCitiesName = () => {
    if (streetParkingBillCities.length === 0) return [];
    return streetParkingBillCities.map(city => {
      return t(`support_city.${city}`);
    });
  };

  const supportPoi = [
    {
      path: PATHS.GAS_STATIONS,
      text: t('landing.usage.location.gas_stations'),
      onClick: () => {
        amplitudeService.track('服務介紹頁-支援場站_點擊', {
          type: '加油',
          component: 'card',
        });
      },
    },
    {
      path: PATHS.PARKINGLOTS,
      text: t('landing.usage.location.parking_lots'),
      onClick: () => {
        amplitudeService.track('服務介紹頁-支援場站_點擊', {
          type: '停車',
          component: 'card',
        });
      },
    },
    // {
    //   path: PATHS.CAR_BEAUTY_STORES,
    //   text: t('landing.usage.location.car_beauty_stores'),
    //   onClick: () => {
    //     amplitudeService.track('服務介紹頁-支援場站_點擊', {
    //       type: '美容廠',
    //       component: 'card',
    //     });
    //   },
    // },
    {
      path: PATHS.AUTO_REPAIR_STORES,
      text: t('landing.usage.location.auto_repair_stores'),
      onClick: () => {
        amplitudeService.track('服務介紹頁-支援場站_點擊', {
          type: '維修廠',
          component: 'card',
        });
      },
    },
    // {
    //   path: PATHS.CAR_WASH_STORES,
    //   text: t('landing.usage.location.car_wash_stores'),
    //   onClick: () => {
    //     amplitudeService.track('服務介紹頁-支援場站_點擊', {
    //       type: '洗車場',
    //       component: 'card',
    //     });
    //   },
    // },
  ];

  return (
    <section className={styles.usage} ref={usageRef}>
      <div className={styles.canvas}>
        <h2>{t('landing.usage.title')}</h2>
        <div className={styles.image}>
          <img className={styles.map} src={map} alt="map" loading="lazy" />
          <img className={pinClass} src={pin} alt="pin" loading="lazy" />
        </div>
        <div className={contentClass}>
          <div className={styles.block}>
            <div className={styles.title}>
              <span className={styles['gradient-text']}>500+ </span>
              {t('landing.usage.location.title')}
            </div>
            <div className={styles.msg}>{t('landing.usage.location.message')}</div>
            <div className={styles.link}>
              {supportPoi.map(item => {
                return (
                  <Link to={currentUrl(item.path)}>
                    <Button type="outline" theme="blue" onClick={item.onClick} customStyle={{ fontSize: fontSize() }}>
                      {item.text}
                    </Button>
                  </Link>
                );
              })}
            </div>
          </div>
          <div className={styles.block}>
            <div className={styles.title}>
              <span className={styles['gradient-text']}>{streetParkingBillCities.length || 17} </span>
              {t('landing.usage.on_street_parking.title')}
            </div>
            <div className={styles.msg}>{t('landing.usage.on_street_parking.message')}</div>
            <div className={styles.support}>
              {t('landing.usage.on_street_parking.support')}
              {supportCitiesName().join(langIsCn ? '、' : ', ')}
              {langIsCn ? '' : '.'}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Usage;
